import React from 'react';
import Box from '@mui/material/Box';
import CmmTitle from './CmmTitle';

export default function CmmContainer(props) {
  const { title, sx, component, children } = props;

  return (
    <Box
      sx={{
        bgcolor: '#fff',
        boxShadow: 1,
        borderRadius: 2,
        p: 2,
        minWidth: 300
      }}
    >
      {title && (
        <Box sx={{ display: 'flex', color: '#46505A', mb: 1, fontWeight: 'bold' }}>
          <span>{title}</span>
          <Box sx={{ flex: 'auto 1 1' }} />
          {component && <div style={{ marginTop: '-8px' }}>{component}</div>}
        </Box>
      )}
      <Box sx={{ ...sx }}>{children}</Box>
    </Box>
  );
}
